import {
  getDefaultAddressId,
  getOrderPreview
} from './orderInfo'
import router from '@/router'
// import addOrderByCake from './addOrderByCake'
// import addOrderByGoods from './addOrderByGoods'

import orderAdd from './addOrder'
import payOrder from './payOrder'
import payAgain from './payAgain'

import { getCurrentAddress } from './address'

// 获取预支付信息
const getPayOrderInfo = async ({ commit, state }, params) => {
    if (state.addressId === '') {
      const res = await getDefaultAddressId({ commit })
      if (res) {
        commit('SET_ADDRESSID', res)
      } else {
        // router.push({
        //   path: '/myaddress#select'
        // })
        return Promise.reject({
          msg: '请先选择地址',
          err_code: 'address_error'
        })
      }
    }

    const res = await getOrderPreview({ state, commit }, params)
    return res.data.data
}

// 下单
const addOrder = async ({ commit, state }, params) => {
  return orderAdd({commit, state}, params)
}

const actions = {
  getPayOrderInfo,
  addOrder,
  payOrder,
  payAgain,
  getCurrentAddress
}

export default actions
